import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Stack } from '../../../../../../../primitives/index.js';
export const StatementList = /*#__PURE__*/_styled(Stack, process.env.NODE_ENV === "production" ? {
  target: "e1qv16vu0"
} : {
  target: "e1qv16vu0",
  label: "StatementList"
})(process.env.NODE_ENV === "production" ? {
  name: "pv1s1f",
  styles: "margin:0;padding:0;list-style:none"
} : {
  name: "pv1s1f",
  styles: "margin:0;padding:0;list-style:none/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0YXRlbWVudExpc3QuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRTJDIiwiZmlsZSI6IlN0YXRlbWVudExpc3QuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBTdGFjayB9IGZyb20gJy4uLy4uLy4uLy4uLy4uLy4uLy4uL3ByaW1pdGl2ZXMvaW5kZXguanMnO1xuZXhwb3J0IGNvbnN0IFN0YXRlbWVudExpc3QgPSBzdHlsZWQoU3RhY2spIGBcbiAgbWFyZ2luOiAwO1xuICBwYWRkaW5nOiAwO1xuICBsaXN0LXN0eWxlOiBub25lO1xuYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN0YXRlbWVudExpc3QuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});